import { Checkbox, CheckboxGroup, FormControl, FormErrorMessage, FormLabel, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { SelectionCriterionDto } from "../../../../../autogen/bff-api";
import { composeCriterionKey } from "../../../../../common/qualification/criterionKey";

interface Props {
  selectionCriteria: SelectionCriterionDto[];
  value: string[];
  onChange: (next: string[]) => void;
  error?: string;
}

export const SupportedCriteriaField = ({ selectionCriteria, value, onChange, error }: Props) => {
  const { t } = useTranslation();
  if (selectionCriteria.length === 0) return null;

  return (
    <FormControl isRequired isInvalid={error !== undefined}>
      <FormLabel fontSize="sm">{t("Which qualification requirements does the company support?")}</FormLabel>
      <CheckboxGroup value={value} onChange={(next) => onChange(next as string[])}>
        <Stack spacing="2">
          {selectionCriteria.map((criterion) => (
            <Checkbox key={composeCriterionKey(criterion)} value={composeCriterionKey(criterion)}>
              <Text fontSize="sm">{criterion.name}</Text>
            </Checkbox>
          ))}
        </Stack>
      </CheckboxGroup>
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
};
